<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn class="mr-1 ml-1 add-course-button" outlined dark v-on="on">
        Import Users
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in importUserOptions"
        :key="index"
        @click="showPanel(index)"
      >
        <v-list-item-title class="text-left">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import ImportCSV from "@/components/admin/users/Import";
import HRPlatform from "@/components/admin/users/HRPlatform";
export default {
  data() {
      return {
        importUserOptions: [
          { title: "CSV" },
          { title: "HR Platform" }
        ]
      };
  },
  props: {
    name: {
      type: String,
      default: null
    }
  },
  methods: {
    showPanel(id) {
      switch (id) {
        case 0:
          this.showCSVImportPanel();
          break;
        case 1:
          this.showHRPlatformPanel();
          break;
      }
    },
    showCSVImportPanel() {
      this.$showPanel({
        component: ImportCSV,
        openOn: 'right',
      });
    },
    showHRPlatformPanel() {
      this.$showPanel({
        component: HRPlatform,
        openOn: 'right',
        props: {
          name: this.name,
        },
      });
    }
  }
};
</script>
